import base from '../base';
import {
  postJsonRequest,
} from '@/util/http';

const STATISTICS = {
  // 交易数据统计
  getStatistics(params) {
    return postJsonRequest(`${base.baseUrl}/pay_data_statistics/query`, params);
  },
};

export default STATISTICS;